import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { Link } from 'react-router-dom';
import L from 'leaflet';
import { Clinic } from '../types/api';

const clinicIcon = L.divIcon({
  html: '<div style="background:#0d9488;color:white;border-radius:50%;width:32px;height:32px;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:18px;box-shadow:0 2px 6px rgba(0,0,0,0.2);">+</div>',
  className: '',
  iconSize: [32, 32],
  iconAnchor: [16, 16],
});

function MapRecenter({ center }: { center: { lat: number; lng: number } }) {
  const map = useMap();
  useEffect(() => {
    map.flyTo([center.lat, center.lng], 12, { duration: 1.5 });
  }, [center.lat, center.lng, map]);
  return null;
}

interface Props {
  clinics: Clinic[];
  center: { lat: number; lng: number };
  userLocation?: { lat: number; lng: number } | null;
}

export default function ClinicMap({ clinics, center, userLocation }: Props) {
  return (
    <MapContainer
      center={[center.lat, center.lng]}
      zoom={11}
      className="h-[400px] w-full z-0"
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MapRecenter center={center} />

      {userLocation && (
        <Marker
          position={[userLocation.lat, userLocation.lng]}
          icon={L.divIcon({
            html: '<div style="background:#f97316;border:3px solid white;border-radius:50%;width:16px;height:16px;box-shadow:0 2px 6px rgba(0,0,0,0.3);"></div>',
            className: '',
            iconSize: [16, 16],
            iconAnchor: [8, 8],
          })}
        />
      )}

      {clinics.map((clinic) => (
        <Marker
          key={clinic.id}
          position={[clinic.lat, clinic.lng]}
          icon={clinicIcon}
        >
          <Popup>
            <div className="min-w-[180px]">
              <p className="font-bold text-navy">{clinic.name}</p>
              <p className="text-xs text-gray-500 mt-1">{clinic.address}, {clinic.island}</p>
              {clinic.phone && <p className="text-xs text-gray-500">{clinic.phone}</p>}
              {clinic.distance_meters != null && (
                <p className="text-xs text-primary font-medium mt-1">
                  {(clinic.distance_meters / 1000).toFixed(1)} km away
                </p>
              )}
              <Link
                to={`/clinics/${clinic.slug}`}
                className="inline-block mt-2 text-xs text-primary font-semibold hover:underline"
              >
                View Details &rarr;
              </Link>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
